"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.WRAPPER = exports.NAME_INPUT = exports.CONTENT = exports.SAVE_BUTTON = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    _Input = require("../../../common/styles/Input");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var SAVE_BUTTON = (0, _cxs["default"])({
  width: "100%",
  marginTop: "10px",
  marginBottom: "10px"
});
exports.SAVE_BUTTON = SAVE_BUTTON;
var CONTENT = (0, _cxs["default"])({
  padding: "0px 10px",
  width: "100%",
  boxSizing: "border-box"
});
exports.CONTENT = CONTENT;
var NAME_INPUT = (0, _cxs["default"])({
  " input": {
    minHeight: "40px !important",
    padding: "10px 20px !important",
    fontSize: "11px !important"
  }
});
exports.NAME_INPUT = NAME_INPUT;
var WRAPPER = (0, _cxs["default"])({
  boxShadow: "rgba(0,0,0,0.5) 0 2px 4px 0px ",
  borderRadius: "6px",
  width: "220px",
  margin: "16px",
  overflow: "hidden",
  background: "white",
  "> .sketch-picker": {
    border: "none !important",
    boxShadow: "none !important",
    borderRadius: "0px !important",
    input: {
      borderRadius: "4px !important"
    },
    "> div:nth-child(3)": {
      "> div:first-child > div": {
        display: "flex !important",
        flexDirection: "column-reverse !important",
        alignItems: "flex-start !important",
        "::after": {
          content: "\"#\"",
          position: "absolute",
          left: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          marginTop: "-5px",
          fontSize: "12px",
          color: "black"
        },
        "> input": _objectSpread({}, (0, _Input.INPUT_STYLE_OBJECT)({}), {
          minHeight: "40px",
          width: "100% !important",
          marginBottom: "10px"
        }),
        "> span": {
          display: "none !important"
        }
      },
      "> div:not(:first-child)": {
        display: "none !important"
      }
    },
    "> div:last-child": {
      display: "none !important"
    }
  },
  "> hr": {
    border: "none",
    background: _vars.COLOURS.grey.catSkillWhite,
    height: "1px",
    width: "calc(100% - 20px)",
    margin: "10px",
    marginTop: "5px"
  }
});
exports.WRAPPER = WRAPPER;